/**
 * D-041: triyajın "Waiting Items" penceresinde salt değişim kaleminin "From stock" seçimi.
 *
 * Saf fonksiyon: web listeyi iki gruba böler, sistem hiçbir kaydı kendiliğinden seçmez. Bir stok kaydı kalemle
 * eşleşir, eğer
 * 1. PN'i kalemin adında, bulgu metninde, önerilen işinde ya da sipariş PN'inde BÜTÜN BİR PARÇA olarak geçiyorsa
 *    (büyük/küçük harf fark etmez; "56004001053" "…Snap Ring - 56004001053)" içinde tutar, "56004001053-2" içinde tutmaz);
 * 2. ya da tanımı, kalem adındaki parantez içi adı ("Retainer (Lock Bolt Snap Ring)" → "Lock Bolt Snap Ring") bütün
 *    kelimeler olarak içeriyorsa.
 * Eşleşenler "Matches the finding text", ötekiler "Other stock records" grubunda; ikisi de PN sırasıyla.
 */
/** Parantez içi adın en az uzunluğu: "(x2)", "(A)" gibi kısa notlar tanımlarda rastgele tutmasın. */
const PARANTEZ_EN_AZ = 4;
const kacir = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
/*
 * Desenlerde geriye bakış ("(?<!…)") yok: iOS/iPadOS 16.3 ve öncesi Safari onu tanımaz ve desen kurulurken hata atar,
 * bu da bütün "Waiting Items" penceresini düşürür. Önceki karakter tüketilerek denetlenir ("(?:^|[^…])"); yalnız
 * .test() kullanıldığı için sonuç aynıdır.
 */
/** Bir parçanın içinde geçtiği yerde önünde ve ardında harf, rakam ya da tire olmamalı. */
const parcaDeseni = (s) => new RegExp(`(?:^|[^A-Za-z0-9-])${kacir(s)}(?![A-Za-z0-9-])`, "i");
/** Kelime dizisi olarak içerme: boşluklar esnek, kelime ortasından tutmaz. */
const kelimeDeseni = (s) => new RegExp(`(?:^|[^A-Za-z0-9])${s.split(/\s+/).map(kacir).join("\\s+")}(?![A-Za-z0-9])`, "i");
/** Kalem adındaki parantez içi adlar ("Retainer (Lock Bolt Snap Ring)" → ["Lock Bolt Snap Ring"]). */
export function parantezAdlari(kalem) {
    return [...kalem.matchAll(/\(([^()]+)\)/g)]
        .map((m) => (m[1] ?? "").trim())
        .filter((s) => s.length >= PARANTEZ_EN_AZ && /[A-Za-z]/.test(s));
}
/** Stok kaydı kalemle eşleşiyor mu (kural başlıktaki yorumda). */
export function stokEslesiyor(kalem, kayit) {
    const pn = kayit.pn.trim();
    if (pn) {
        const d = parcaDeseni(pn);
        if ([kalem.kalem, kalem.bulgu, kalem.onerilenIs, kalem.siparisPn].some((m) => Boolean(m) && d.test(m)))
            return true;
    }
    const tanim = kayit.tanim ?? "";
    return tanim !== "" && parantezAdlari(kalem.kalem).some((ad) => kelimeDeseni(ad).test(tanim));
}
/** PN sırası: düz karakter sırası (dile göre sıralama tireyi ve harfleri farklı dizebilir). */
const pnSirasi = (a, b) => (a.pn < b.pn ? -1 : a.pn > b.pn ? 1 : 0);
/** "From stock" seçiminin iki grubu: kalemle eşleşenler ve ötekiler, ikisi de PN sırasıyla. */
export function stokSecenekleri(kalem, stok) {
    const eslesen = [];
    const diger = [];
    for (const s of [...stok].sort(pnSirasi))
        (stokEslesiyor(kalem, s) ? eslesen : diger).push(s);
    return { eslesen, diger };
}
//# sourceMappingURL=stok-eslesme.js.map